import {
  buildCmsUrl,
  CMSApiBase,
  CMSGroupParams,
  getResponseCMS,
} from './base';
import { factory, getResponseCamelization } from '@repo-level/core-front';

export interface ReferralHowToParticipateCard {
  title: string;
  description: string;
  id: number;
}

export interface ReferralDataItem {
  question: string;
  answer: string;
}

export interface ReferralHowToCard {
  title: string;
  description: string;
}

export interface ReferralHowToParticipate extends CMSGroupParams {
  cards: ReferralHowToParticipateCard[];
  content: ReferralHowToCard[];
}

export interface RefferalProgramApi extends CMSApiBase {
  title: string;
  description: string;
  bonusTitle: string;
  bonusSubtitle: string;
  howToTitle: string;
  enable: boolean;
  referralBonusOld?: string;
  referralBonusNew: string;
  howToParticipate: ReferralHowToParticipate;
  faqTitle: string;
  questions: ReferralDataItem[];
  cards: ReferralHowToParticipateCard[];
}

export const referralProgram = factory((r) => (lang: string) =>
  r<RefferalProgramApi>(
    'get',
    buildCmsUrl({
      path: 'referral-program',
      lang,
      additionalParams: { populate: 'deep' },
    }),
    undefined,
    { transformResponse: [getResponseCamelization(), getResponseCMS] }
  )
);
